import { Box, Typography } from '@mui/material';
import { ReactComponent as gifIcon } from '../../../../../../../../../assets/gif.svg';
import { ReactComponent as jpegIcon } from '../../../../../../../../../assets/jpeg.svg';
import { ReactComponent as jpgIcon } from '../../../../../../../../../assets/jpg.svg';
import { ReactComponent as mp4Icon } from '../../../../../../../../../assets/mp4.svg';
import { ReactComponent as pdfIcon } from '../../../../../../../../../assets/pdf.svg';
import { ReactComponent as pngIcon } from '../../../../../../../../../assets/png.svg';
import { ReactComponent as svgIcon } from '../../../../../../../../../assets/svg.svg';
import { ReactComponent as webpIcon } from '../../../../../../../../../assets/webp.svg';
import zeplinColor from '../../../../../../../../../theme/Color';
import { Utilities } from '../../../../../../../../../utilities/utilities';
import CustomButton from '../../../../../../../../shared/CustomButton/CustomButton';
import { LightTooltip } from '../../../../../../../../shared/CustomTooltip/CustomTooltip';

const fileIconComponents = {
  mp4: mp4Icon,
  pdf: pdfIcon,
  png: pngIcon,
  jpg: jpgIcon,
  jpeg: jpegIcon,
  gif: gifIcon,
  webp: webpIcon,
  svg: svgIcon,
};

export default function FileRow({
  file,
  handleDeleteFile,
  index,
}: {
  file: File;
  handleDeleteFile: (index: number) => void;
  index: number;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: zeplinColor.Neutral1,
        padding: '0px 4px',
      }}
    >
      <Box sx={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        {(() => {
          const extension = Utilities.getFileExtension(file.name);
          const IconComponent = fileIconComponents[extension as keyof typeof fileIconComponents];
          return <IconComponent aria-label='file icon' style={{ width: '40px', height: '40px' }} />;
        })()}
        <Box sx={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
          <LightTooltip
            title={
              <Typography variant='body3' color={zeplinColor.Neutral1}>
                {file.name}
              </Typography>
            }
            placement='bottom-end'
            style={{
              backgroundColor: zeplinColor.BasicBlack,
              borderRadius: '8px',
            }}
          >
            <Typography variant='body2'>
              {file?.name ? file?.name?.slice(0, 40) : file?.toString()?.slice(0, 40)}
              {file?.name
                ? file?.name?.length > 40 && '...'
                : file?.toString()?.length > 40 && '...'}
            </Typography>
          </LightTooltip>
          <Typography variant='label1'>{Utilities.formatBytesToMB(file.size)}MB</Typography>
        </Box>
      </Box>
      <CustomButton
        style={{
          width: '24px',
          height: '24px',
          minWidth: '24px',
          padding: 0,
          '.MuiButton-startIcon': {
            margin: 0,
          },
        }}
        variant='text'
        text=''
        icon={
          <img
            width={'24px'}
            height={'24px'}
            src={'/assets/cross.svg'}
            alt='logo'
            style={{ objectFit: 'cover', margin: 0 }}
          />
        }
        onClick={() => handleDeleteFile(index)}
        disabled={false}
      />
    </Box>
  );
}
